module.exports = __webpack_public_path__ + "img/route.30a200a9.png";